var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM6.46875 5.46875C6.15625 5.78125 6.15625 6.25 6.46875 6.53125L7.9375 8L6.46875 9.46875C6.15625 9.78125 6.15625 10.25 6.46875 10.5312C6.75 10.8438 7.21875 10.8438 7.5 10.5312L8.96875 9.0625L10.4375 10.5312C10.75 10.8438 11.2188 10.8438 11.5 10.5312C11.8125 10.25 11.8125 9.78125 11.5 9.46875L10.0312 8L11.5 6.53125C11.8125 6.25 11.8125 5.78125 11.5 5.46875C11.2188 5.1875 10.75 5.1875 10.4375 5.46875L8.96875 6.9375L7.5 5.46875C7.21875 5.1875 6.75 5.1875 6.46875 5.46875Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOff);
export default __webpack_public_path__ + "static/media/check-circle-off.a508515e9f660fe502b6e0719a0d9914.svg";
export { ForwardRef as ReactComponent };